import { useMemo } from "react";
import { DateTime } from "luxon";
import { Column } from "react-table";
import { GetBlockchainAnimalDataByKillNumber_blockchainAnimalDataByKillNumber_medication } from "api/Blockchain/types/GetBlockchainAnimalDataByKillNumber";
import { GetBlockchainAnimalDataByPassport_blockchainAnimalDataByPassport_medication } from "api/Blockchain/types/GetBlockchainAnimalDataByPassport";
import { Spacer, Table, Text, Title } from "components";
import { TABLE_IDS } from "constants/Interface";
import { AnimalDataTypes } from "../";

type AnimalMedicationType =
  | GetBlockchainAnimalDataByPassport_blockchainAnimalDataByPassport_medication
  | GetBlockchainAnimalDataByKillNumber_blockchainAnimalDataByKillNumber_medication;

interface BlockchainAnimalMedicationTableProps {
  medication: AnimalDataTypes["medication"];
}

const COLUMN_IDS = {
  HOLDING_ID: "holdingId",
  MEDICINE_NAME: "medicineName",
  DATE: "date",
  BATCH_NUMBER: "batchNumber",
  DOSAGE: "dosage",
  DOSAGE_UNITS: "dosageUnits",
  ACTIVE_INGREDIENT: "activeIngredient",
  WITHDRAWAL_DAYS: "withdrawalDays",
  CREATED_BY: "createdBy",
};

export const BlockchainAnimalMedicationTable: React.FC<BlockchainAnimalMedicationTableProps> = ({ medication }) => {
  const data = useMemo(() => medication, []);

  //@ts-expect-error
  const columns: Column<AnimalMedicationType>[] = useMemo(
    () => [
      {
        id: COLUMN_IDS.HOLDING_ID,
        Header: "Holding Id",
        accessor: "holdingId",
      },
      {
        id: COLUMN_IDS.BATCH_NUMBER,
        Header: "Batch Number",
        accessor: "batchNumber",
      },
      {
        id: COLUMN_IDS.MEDICINE_NAME,
        Header: "Medicine Name",
        accessor: "medicineName",
      },
      {
        id: COLUMN_IDS.DOSAGE,
        Header: "Dosage",
        accessor: "dosage",
      },
      {
        id: COLUMN_IDS.DOSAGE_UNITS,
        Header: "Dosage Units",
        accessor: "dosageUnits",
      },
      {
        id: COLUMN_IDS.ACTIVE_INGREDIENT,
        Header: "Active Ingredient",
        accessor: "activeIngredient",
      },
      {
        id: COLUMN_IDS.WITHDRAWAL_DAYS,
        Header: "Withdrawal Days",
        accessor: "withdrawalDays",
      },
      {
        id: COLUMN_IDS.DATE,
        Header: "Date",
        accessor: "date",
        Cell: ({ row }) =>
          row.values[COLUMN_IDS.DATE] ? DateTime.fromISO(row.values[COLUMN_IDS.DATE]).toLocaleString() : "\u2014",
      },
      {
        id: COLUMN_IDS.CREATED_BY,
        Header: "Created By",
        accessor: "createdBy",
      },
    ],
    [],
  );

  return (
    <>
      <Title secondary>Medication</Title>

      <Spacer baselineHeight={1} />

      {data?.length ? (
        <Table<AnimalMedicationType> columns={columns} data={data} tableId={TABLE_IDS.BLOCKCHAIN_ANIMAL_MEDICATION} />
      ) : (
        <Text smallest>
          <em>No Medication Data for this Animal</em>
        </Text>
      )}
    </>
  );
};
